import { DatiUIU } from './../../model/dati-uiu.model';
import { Action } from '@ngrx/store'

export const SET_DATI_UIU = '[SET_DATI_UIU] SetDatiUiu';

export class SetDatiUiu implements Action {
    readonly type = SET_DATI_UIU

    constructor(public payload: DatiUIU) {}
}

export type Actions = SetDatiUiu